import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const UserManualIcon = () => {
    return (
        <svg width="33" height="47" viewBox="0 0 33 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#9pkpfpykca)">
                <path
                    d="M20.756 40.012h11.232V1.5H3.5a2 2 0 0 0-2 2v35.01a2 2 0 0 0 1.441 1.92l17.815 5.18V10.303L4.174 4.71M27.709 7.919H13.802M27.244 12.198h-6M27.244 16.477h-6M27.244 20.756h-6M27.244 25.035h-6M27.244 29.314h-6M27.244 33.593h-6"
                    stroke="#002856"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.972 29v-1.179c0-.527.087-1.005.262-1.433.175-.43.393-.836.653-1.22s.543-.761.849-1.132c.305-.37.588-.759.848-1.165a6.88 6.88 0 0 0 .654-1.313c.175-.469.262-.994.262-1.574a7.07 7.07 0 0 0-.24-1.836 4.535 4.535 0 0 0-.77-1.594 3.95 3.95 0 0 0-1.368-1.125c-.559-.286-1.236-.429-2.033-.429-.655 0-1.256.143-1.803.429a4.356 4.356 0 0 0-1.43 1.212c-.405.523-.725 1.15-.96 1.882a8.915 8.915 0 0 0-.396 2.425h1.53a7.198 7.198 0 0 1 .268-1.768c.156-.536.368-.994.636-1.373.268-.38.585-.677.95-.891a2.336 2.336 0 0 1 1.205-.322c.477 0 .892.09 1.245.268.354.179.648.42.883.724.234.303.407.663.519 1.078.111.415.167.855.167 1.32a3.8 3.8 0 0 1-.285 1.5c-.19.447-.43.864-.72 1.253-.29.388-.6.761-.932 1.119-.331.357-.642.73-.932 1.118-.29.389-.53.804-.72 1.246a3.75 3.75 0 0 0-.286 1.494V29h1.944zM12 34v-2h-2v2h2z"
                    fill="#002856"
                />
            </g>
            <defs>
                <clipPath id="9pkpfpykca">
                    <path fill="#fff" d="M0 0h33v47H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default UserManualIcon;
